import React, { useState, useEffect } from "react";
import "./../../../assets/css/purchase/form.css";

// React DateTime
import Datetime from "react-datetime";
import moment from "moment";

// Components
import Breadcrumbs from "../../components/Breadcrumbs";
import Sidebar from "../../components/Sidebar";
import ReportsTable from "../../components/Content/ReportsTable";

// Utils
import { formatDateOnChange, formatStringDateToDate } from "../../../utils/DateUtils";
import { getAlert, getDataWithComp } from "../../../utils/SamuiUtils";

const SalesReport = () => {
    // ตัวแปรเก็บชื่อหน้าจอ
    const [name, setName] = useState(null);

    // ตัวแปรเก็บค่าเงื่อนไขการค้นหา
    const [searchCriteria, setSearchCriteria] = useState([]);

    // ข้อมูลที่แสดงรายงาน
    const [filteredData, setFilteredData] = useState([]);

    // สำหรับ Table รายงาน
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(16);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

    useEffect(() => {
        initialize();
    }, []);

    const initialize = async () => {
        // เริ่มต้นหน้าจอ (เปิดครั้งแรก)
        setName("1. รายงานยอดซื้อ / ขายประจำวัน");
        setSearchCriteria(
            {
                docDate: formatDateOnChange(new Date()),
                arCode: null,
                arName: null,
                docIsPickingList: null,
                docStatusPaidType: null
            }
        );
        setFilteredData([]);
    };

    const handleChangeCriteria = (e) => {
        const { name, value } = e.target;
        setSearchCriteria((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleChangeDate = (value, name) => {
        const newValue =
            value && value instanceof moment ? value.format("YYYY-MM-DD") : value;
        setSearchCriteria((prev) => ({
            ...prev,
            [name]: formatDateOnChange(newValue),
        }));
    };

    const handleSearch = async () => {
        try {
            setFilteredData([]);

            let query = '';
            
            // ระบุ columns ที่ต้องการเพื่อลดข้อมูลที่ดึงมา
            const columns = 'Doc_ID, Doc_No, Doc_Date, Doc_SEQ, Doc_Status, Doc_Status_Paid, Doc_Status_Paid_Type, Doc_Is_PickingList, AR_Code, AR_Name, NetTotal, WH_Id, Comp_Id';

            if (searchCriteria.docDate) {
                // เปลี่ยนจาก CONVERT(DATE, Doc_Date) เป็น BETWEEN เพื่อให้ Index ใช้งานได้
                const formattedDate = formatStringDateToDate(searchCriteria.docDate).split(' ')[0];
                query += `AND Doc_Date >= '${formattedDate} 00:00:00' AND Doc_Date <= '${formattedDate} 23:59:59' `;
            }

            if (searchCriteria.arCode) {
                query += `AND AR_Code = '${searchCriteria.arCode}' `;
            }
            if (searchCriteria.arName) {
                query += `AND AR_Name = '${searchCriteria.arName}' `;
            }
            if (searchCriteria.docIsPickingList !== null && searchCriteria.docIsPickingList !== undefined) {
                query += searchCriteria.docIsPickingList === 1
                    ? 'AND Doc_Is_PickingList = 0 '
                    : 'AND Doc_Is_PickingList <> 0 ';
            }
            if (searchCriteria.docStatusPaidType) {
                query += `AND Doc_Status_Paid_Type = '${searchCriteria.docStatusPaidType}' `;
            }

            // เพิ่ม ORDER BY เพื่อให้ database ทำการ sort แทน frontend
            query += 'ORDER BY Doc_Date DESC, Doc_No DESC ';

            const response = await getDataWithComp('API_0701_SO_H', query.trim(), columns);

            if (response && response.length > 0) {
                setFilteredData(response);
            }
        } catch (error) {
            getAlert("FAILED", error.response?.message || error.message);
        }
    };


    return (
        <>
            <Sidebar />
            <div className="main-panel">
                <div className="container">
                    <div className="page-inner">
                        <div className="page-header d-flex justify-content-between align-items-center">
                            <Breadcrumbs
                                page={name}
                                items={[
                                    { name: "รายงาน", url: "/reports" },
                                    { name: name, url: "/sales-report" },
                                ]}
                            />
                        </div>
                        <div className="row">
                            {/* Criteria */}
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h4>เงื่อนไขการค้นหา</h4>
                                    </div>
                                    <div className="card-body">
                                        <form className="row g-3">
                                            <div className="col-md-2">
                                                <label htmlFor="docDate" className="form-label">วันที่เอกสาร</label>
                                                <Datetime
                                                    id="docDate"
                                                    className="input-spacing-input-date"
                                                    value={searchCriteria.docDate}
                                                    dateFormat="DD-MM-YYYY"
                                                    timeFormat={false}
                                                    onChange={(date) => handleChangeDate(date, "docDate")}
                                                    inputProps={{ readOnly: true, disabled: false }}

                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <label htmlFor="arCode" className="form-label">รหัสลูกค้า</label>
                                                <input
                                                    type="text"
                                                    className="form-control input-spacing"
                                                    id="arCode"
                                                    name="arCode"
                                                    value={searchCriteria.arCode || ""}
                                                    onChange={handleChangeCriteria}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <label htmlFor="arName" className="form-label">ชื่อลูกค้า</label>
                                                <input
                                                    type="text"
                                                    className="form-control input-spacing"
                                                    id="arName"
                                                    name="arName"
                                                    value={searchCriteria.arName || ""}
                                                    onChange={handleChangeCriteria}
                                                />
                                            </div>
                                            <div className="col-md-4"></div>
                                            <div className="col-md-3">
                                                <label htmlFor="docIsPickingList" className="form-label">หลังบ้าน/Vansale</label>
                                                <select
                                                    className="form-select form-control input-spacing"
                                                    id="docIsPickingList"
                                                    name="docIsPickingList"
                                                    value={searchCriteria.docIsPickingList || ""}
                                                    onChange={handleChangeCriteria}
                                                >
                                                    <option value={null}>ทั้งหมด</option>
                                                    <option value={1}>Admin</option>
                                                    <option value={2}>Vansale</option>
                                                </select>
                                            </div>
                                            <div className="col-md-3 mb-4">
                                                <label htmlFor="docStatusPaidType" className="form-label">ประเภทการชำระเงิน</label>
                                                <select
                                                    className="form-select form-control input-spacing"
                                                    id="docStatusPaidType"
                                                    name="docStatusPaidType"
                                                    value={searchCriteria.docStatusPaidType || ""}
                                                    onChange={handleChangeCriteria}
                                                >
                                                    <option value={null}>ทั้งหมด</option>
                                                    <option value={1}>สด</option>
                                                    <option value={2}>โอน</option>
                                                    <option value={3}>เช็ค</option>
                                                    <option value={4}>เครดิต</option>
                                                </select>
                                            </div>
                                            <div className="col-md-12 d-flex justify-content-end">
                                                <button
                                                    type="button"
                                                    className="btn btn-lg shadow text-white"
                                                    style={{ width: '10%', marginRight: '20px', backgroundColor: '#EF6C00', fontSize: '16px' }}
                                                    onClick={() => handleSearch()}
                                                >
                                                    <i className="fas fa-search" /> ค้นหา
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-lg shadow text-white"
                                                    style={{ width: '10%', backgroundColor: '#EF6C00', fontSize: '16px' }}
                                                    onClick={() => initialize()}
                                                >
                                                    <i className="fas fa-undo" /> เริ่มใหม่
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            {/* ReportsTable */}
                            <ReportsTable
                                currentItems={currentItems}
                                currentPage={currentPage}
                                handlePageChange={(pageNumber) => setCurrentPage(pageNumber)}
                                dataMasterList={filteredData}
                                itemsPerPage={itemsPerPage}
                                fieldMappings={{
                                    docDate: 'Doc_Date',
                                    docNo: 'Doc_No',
                                    docIsPickingList: 'Doc_Is_PickingList',
                                    statusPaidName: 'DocStatusPaid_Name',
                                    statusPaidColour: 'DocStatusPaid_Colour',
                                    payTypeName: 'DocStatusPaid_Type_Name',
                                    payTypeColor: 'DocStatusPaidType_Colour',
                                    arCode: 'AR_Code',
                                    arName: 'AR_Name',
                                    netTotal: 'NetTotal'
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
};

export default SalesReport;